module.exports = __webpack_public_path__ + "img/title7.8fd6b805.png";